import styled from "styled-components";
import { LOGO_LG } from "@assets";
import { Form as AntForm, Divider as AntDivider } from "antd";
import { BackOutlined } from '@assets';

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: linear-gradient(
    180deg,
    rgba(74, 14, 68, 1) 15%,
    rgba(30, 23, 47, 1) 60%
  );
  padding: 0px 29px;

  .ant-btn-primary {
    width: 100%;
    height: 52px;
    border-radius: 10px !important;
  }

  #login-btn {
    margin-bottom: 30px;
  }
`;

export const SkipLink = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #d69c17;
  cursor: pointer;
`;

export const Title = styled.div`
padding-bottom: 30px;
  color: #FFF !important;
  text-align: center;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 400 !important;
  line-height: normal !important;
` 

export const Logo = styled.img.attrs({
  alt: "logo",
  src: LOGO_LG,
})`
  width: 180px;
  height: auto;
  object-fit: contain;
  padding: 35px 0;
`;

export const Form = styled(AntForm)`
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item:last-child {
    margin-bottom: 0 !important;
  }

  .ant-form-item-label {
    text-align: center;
  }

  .ant-form-item-label label {
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }

  .ant-input-affix-wrapper {
    height: 52px;
    border: 1px solid #e1cce0;
    border-radius: 10px;

    input {
      height: auto !important;
      text-align: center;
    }
  }

  input {
    height: 52px;
    border: 1px solid #e1cce0;
    border-radius: 10px;
    text-align: center;
  }

  .ant-btn-primary {
    margin-top: 8px;
  }
`;

export const BottomText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #ffffff;
  margin-bottom: 30px;
`;

export const Link = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.theme.primaryColor};
  cursor: pointer;
`;

export const Divider = styled(AntDivider)`
  margin: 40px 0 !important;

  .ant-divider-inner-text {
    font-size: 18px;
    font-weight: normal;
    color: #ffffff;
  }

  ::before,
  ::after {
    border: 1px solid #e1cce0;
    border-color: #e1cce0 !important;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
`;

export const BackIcon = styled(BackOutlined)`
  font-size: 24px;
  color: #fff;
  cursor: pointer;
`;

export const GoogleLoginButton = styled.div`
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const SpaceBetweenTopBottom = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const TelegramRegisterButton = styled.div`
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;